export const popup_action = "popup_action/change";


export const popupShow = (code, data, callback=null) => ({
    type: popup_action,
    payload: {
        display: true,
        code,
        data,
        callback
    }
});

export const popupHide = () => ({
    type: popup_action,
    payload: {
        display: false,
        code: null,
        data: null,
        callback: null
    }
});


// WEBPACK FOOTER //
// ./src/libs/redux/actions/popup.js